import { Component, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material/material.module';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { CustomValidators } from 'src/app/shared/extensions/CustomValidators';
import { signalSlice } from 'ngxtension/signal-slice';
import { tap, map } from 'rxjs';
import { layerExportTypes } from '../../data-access/state';
import { Statement } from '@angular/compiler';



@Component({
    selector: 'app-download-layer-dialog',
    imports: [CommonModule, MaterialModule, ReactiveFormsModule],
    templateUrl: './download-layer-dialog.component.html',
    styleUrl: './download-layer-dialog.component.css'
})
export class DownloadLayerDialogComponent {

  form = new FormGroup({
    format: new FormControl<layerExportTypes>('kml', [CustomValidators.required]),
    srid:new FormControl<number>(3857)
  });


  initialFormState = {
    ...this.form.getRawValue(),
    status: 'loading' as
      | 'loading'
      | 'loaded'
      | 'submitting'
      | 'success'
      | 'error',
  };

  formState = signalSlice({
    initialState: this.initialFormState,
    sources: [
      formValues(this.form),
    ],
    selectors: (state) => ({
       showSridField: () => state.format() == 'geojson',
    }),
    actionSources: {
  }});

  constructor(public dialogRef: MatDialogRef<DownloadLayerDialogComponent>) {


    effect(() => {

      const type = this.formState.format();

      if(type == 'geojson')
      {
        this.form.controls.srid.addValidators(CustomValidators.required);
      }
      else
      {
        this.form.controls.srid.removeValidators(CustomValidators.required);
      }


    })


  }

download()
{
  this.dialogRef.close(this.form.getRawValue());
}
}
export function formValues(form: FormGroup) {
  return form.valueChanges.pipe(map(() => form.getRawValue()));
}
